import script from "./TagTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagTable.vue?vue&type=script&setup=true&lang=ts"

import "./TagTable.vue?vue&type=style&index=0&id=379e7622&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-379e7622"]])

export default __exports__